const USER_NAMESPACE = '@baps-oj/user';
const CONTESTS_NAMESPACE = '@baps-oj/contests';
const USER_DATA = `${USER_NAMESPACE}/info`;
const USER_TOKEN = `${USER_NAMESPACE}/token`;

export { USER_NAMESPACE, CONTESTS_NAMESPACE, USER_DATA, USER_TOKEN };
